/** Modules */
import { CommonModule, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localFr from '@angular/common/locales/fr';
import { LOCALE_ID, NgModule } from '@angular/core';

/** Components */
import { BrowserModule } from '@angular/platform-browser';
import { RouterLink, RouterOutlet } from '@angular/router';
import { InputComponent } from '@app/shared/components/atoms/input/input.component';
import { MenuComponent } from '@app/shared/components/molecules/menu/menu.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PasswordInputComponent } from '@app/shared/components/molecules/password-input/password-input.component';
import { PipeModule } from '@app/shared/modules/pipe.module';
import { AppRoutingModule } from '@app/routing/app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AlertCardComponent } from '@app/shared/components/molecules/alert-card/alert-card.component';
import { HomePageComponent } from '@app/components/home-page/home-page.component';
import { HeaderComponent } from '@app/components/header/header.component';
import { MenuNavigationComponent } from '@app/components/menu-navigation/menu-navigation.component';
import { MainContentComponent } from '@app/components/main-content/main-content.component';
import { SpinnerComponent } from '@app/shared/components/atoms/loaders/spinner/spinner.component';
import { ButtonComponent } from '@app/shared/components/atoms/buttons/button.component';
import { InvoicesComponent } from '@app/components/invoice/invoices.component';
import { BaseTableComponent } from '@app/shared/components/organisms/table/base-table.component';
import { ColumnHeaderComponent } from '@app/shared/components/organisms/table/column-header/column-header.component';
import { SharedModule } from '@app/shared/shared.module';
import { DialogComponent } from '@app/shared/components/organisms/dialog/dialog.component';
import { SummaryInvoicesComponent } from '@app/components/main-content/summary-invoices/summary-invoices.component';
import { IconComponent } from './shared/components/atoms/icon/icon.component';
import { InputNumberComponent } from './shared/components/atoms/input-number/input-number.component';
import { AppComponent } from './components/app.component';
import { FileInputComponent } from './shared/components/atoms/file-input/file-input.component';
import { AuthInterceptor } from './shared/auth/auth.interceptor';
import { ErrorInterceptor } from './shared/auth/error.interceptor';
import { AlertComponent } from './shared/components/organisms/alert/alert.component';
import { ReportMessageComponent } from './shared/components/molecules/report-message/report-message.component';
import { ErrorLogComponent } from './components/main-content/error-log/error-log.component';
import { SettingsComponent } from './components/settings/settings.component';
import { CheckboxComponent } from './shared/components/atoms/checkbox/checkbox.component';
import { ToggleSwitchComponent } from './shared/components/molecules/toggle-switch/toggle-switch.component';
import { ToggleSwitchCheckComponent } from './components/invoice/toggle-switch-check/toggle-switch-check.component';
import { TresholdNotificationComponent } from './components/main-content/treshold-notification/treshold-notification.component';
import { AlertLogComponent } from '@app/components/alert-log/alert-log.component';
import { CustomErrorComponent } from '@app/shared/components/atoms/custom-error/custom-error.component';
import { DatePickerComponent } from '@app/shared/components/atoms/date-picker/date-picker.component';
import { EditedInvoiceComponent } from '@app/components/edited-invoice/edited-invoice.component';
import { ExpansionPanelComponent } from '@app/shared/components/molecules/expansion-panel/expansion-panel.component';
import { LabelComponent } from './shared/components/atoms/label/label.component';
import { SidenavComponent } from '@app/shared/components/molecules/sidenav/sidenav.component';
import { LoaderComponent } from './shared/components/atoms/loaders/global/loader.component';
import { ContractsComponent } from './components/contracts/contracts.component';
import { DateRangePickerComponent } from './shared/components/atoms/date-range-picker/date-range-picker.component';
import { SelectComponent } from './shared/components/atoms/select/select.component';
import { SsoSignInHeaderComponent } from '@app/components/sso-sign-in-header/sso-sign-in-header.component';
import { TooltipComponent } from './shared/components/atoms/tooltip/tooltip.component';
import { BadgeNotificationComponent } from './shared/components/atoms/badge-notification/badge-notification.component';
import { BadgeComponent } from '@app/components/badge/badge.component';

registerLocaleData(localFr, 'fr');

@NgModule({
  declarations: [
    /** Components */
    AppComponent,
    InputComponent,
    MenuComponent,
    PasswordInputComponent,
    HomePageComponent,
    HeaderComponent,
    MenuNavigationComponent,
    MainContentComponent,
    FileInputComponent,
    AlertComponent,
    AlertCardComponent,
    InvoicesComponent,
    DialogComponent,
    AlertLogComponent,
    ContractsComponent,
    ReportMessageComponent,
    ErrorLogComponent,
    SettingsComponent,
    InputNumberComponent,
    SummaryInvoicesComponent,
    ToggleSwitchCheckComponent,
    TresholdNotificationComponent,
    CustomErrorComponent,
    DatePickerComponent,
    DateRangePickerComponent,
    EditedInvoiceComponent,
    SidenavComponent,
  ],
  bootstrap: [AppComponent],
  exports: [SpinnerComponent],
  imports: [
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    RouterOutlet,
    RouterLink,
    AppRoutingModule,
    PipeModule,
    CommonModule,
    ColumnHeaderComponent,
    IconComponent,
    ButtonComponent,
    SelectComponent,
    BaseTableComponent,
    CheckboxComponent,
    SpinnerComponent,
    SharedModule.forRoot(),
    ToggleSwitchComponent,
    ExpansionPanelComponent,
    LabelComponent,
    LoaderComponent,
    SsoSignInHeaderComponent,
    TooltipComponent,
    BadgeNotificationComponent,
    BadgeComponent,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'fr' },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
